const white = {
    100: '#fff',
    90: '#F4F6F8',
    80: '#E3E5E7',
};

const grey = {
    light: '#ccc',
};

const black = {
    100: '#212B36',
    90: '#637381',
};

const red = {
    100: '#B72136',
    20: 'rgba(183, 33, 54, 0.2)',
};

const blue = {
    100: '#003087',
    90: '#253746',
};

const orange = {
    100: '#F44336',
    50: '#faad14',
};

const green = {
    100: '#52c41a',
};

export { white, grey, black, red, blue, orange, green };
